import { Navigate, Outlet } from 'react-router-dom';
import { FullScreenLoader } from '@/components/common/FullScreenLoader';
import { LegalAcceptanceGate } from '@/components/legal/LegalAcceptanceGate';
import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import { useAuth } from '@/hooks/useAuth';
import { resolveHomeRoute } from '@/lib/resolveHomeRoute';

export function RequireClientAccess() {
  const { status, platformPermissions, activeMembership, activeScopeCode } = useAuth();

  if (status === 'loading') {
    return <FullScreenLoader />;
  }
  if (status === 'unauthenticated') {
    return <Navigate to={APPLICATION_ROUTES.login} replace />;
  }
  if (activeMembership === null || activeMembership.scopeCode !== 'client') {
    return <Navigate to={resolveHomeRoute(activeScopeCode, platformPermissions)} replace />;
  }
  return (
    <LegalAcceptanceGate>
      <Outlet />
    </LegalAcceptanceGate>
  );
}
